export const GENOGRAM_REVIEW_SCOPE_KEY = "genogram"
export const GENOGRAM_REVIEW_BLOCK_AFTER_PAYMENT_MS = 6 * 60 * 60 * 1000
export const GENOGRAM_REVIEW_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000
export const GENOGRAM_REVIEW_MAX_DISMISS_COUNT = 2
export const GENOGRAM_MEANINGFUL_USAGE_STREAK_MS = 0.5 * 60 * 1000//20 * 60 * 1000
export const GENOGRAM_MEANINGFUL_USAGE_CUMULATIVE_MS = 2 * 60 * 1000//60 * 60 * 1000
export const GENOGRAM_MEANINGFUL_USAGE_IDLE_GAP_MS = 0.2 * 60 * 1000//2 * 60 * 1000
export const GENOGRAM_PUBLIC_REVIEW_URL = "https://www.g2.com/products/easygenogram-by-qwoach/take_survey"
